module.exports = {"430821100":"零阳镇","430821101":"岩泊渡镇","430821102":"溪口镇","430821103":"东岳观镇","430821104":"通津铺镇","430821105":"杉木桥镇","430821106":"象市镇","430821107":"江垭镇","430821108":"苗市镇","430821109":"零溪镇","430821110":"高桥镇","430821111":"龙潭河镇","430821112":"广福桥镇","430821113":"三合镇","430821114":"二坊坪镇","430821200":"南山坪乡","430821202":"洞溪乡","430821209":"杨柳铺乡","430821211":"三官寺土家族乡","430821212":"高峰土家族乡","430821213":"许家坊土家族乡","430821214":"金岩土家族乡","430821215":"赵家岗土家族乡","430821216":"甘堰土家族乡","430821217":"阳和土家族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430821.json
// module id = 1882
// module chunks = 0